import styled from 'styled-components';

import { displayPrice } from '../../utils';
import { colors, spacing } from '../../constants';

const Price = styled.span``;
const PriceFrom = styled.span``;
const Text = styled.span``;
const ItemColumn = styled.div``;
const SubLabel = styled.span``;

interface IProps {
    bold?: boolean;
    className?: string;
    isDiscount?: boolean;
    isTotal?: boolean;
    item: string;
    price: number;
    priceFrom?: number;
    included?: boolean;
    subLabel?: string;
}

const BasePriceLine = ({
    item,
    price,
    priceFrom,
    className,
    isDiscount,
    included,
    subLabel,
}: IProps) => (
    <div className={className}>
        {subLabel ? (
            <ItemColumn>
                <span>{item}</span>
                <SubLabel>{subLabel}</SubLabel>
            </ItemColumn>
        ) : (
            item
        )}
        <span>
            {included ? (
                <Text>inbegrepen</Text>
            ) : (
                <>
                    {priceFrom && (
                        <PriceFrom>{displayPrice(priceFrom)}</PriceFrom>
                    )}
                    <Price>
                        {isDiscount && '-'} {displayPrice(price)}
                    </Price>
                </>
            )}
        </span>
    </div>
);

export const PriceLine = styled(BasePriceLine)`
    padding: ${spacing.sm} 0;
    display: flex;
    align-items: ${({ subLabel }) => (subLabel ? 'flex-end' : 'center')};
    justify-content: space-between;
    font-weight: ${({ bold }) => (bold ? 700 : 400)};
    font-size: ${({ isTotal }) => (isTotal ? '18px' : '16px')};
    color: ${({ isDiscount }) => isDiscount && colors.primary};

    ${Price} {
        font-size: ${({ isTotal }) => (isTotal ? '20px' : '18px')};
        font-weight: ${({ bold }) => (bold ? 700 : 400)};
        font-family: 'Campton', Arial, Helvetica, sans-serif;
        color: ${({ priceFrom }) => priceFrom && colors.orange};
    }

    ${PriceFrom} {
        text-decoration: line-through;
        color: ${colors.grey};
        font-weight: 300;
        margin-right: 6px;
        font-size: 18px;
    }

    ${Text} {
        font-size: 14px;
    }

    ${ItemColumn} {
        display: flex;
        flex-direction: column;
    }

    ${SubLabel} {
        font-size: 14px;
        color: ${colors.orange};
        margin-top: 2px;
    }
`;
